import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What space and power do you need?",
    a: "Our coffee cart typically needs a 10x10 ft level space and access to a dedicated 240-volt outlet. For outdoor or remote events without 240V power, we can bring a quiet generator — just let us know in advance.",
  },
  {
    q: "What's the minimum guest count?",
    a: "We cater events of all sizes, from intimate gatherings of 25 to large celebrations of several hundred. Reach out with your guest count and we'll recommend the right package.",
  },
  {
    q: "Do you charge a travel fee?",
    a: "We serve the greater Puget Sound area from Kingston, WA. Travel within our core service area is included; longer distances may include a modest travel fee, which we'll always outline clearly in your quote.",
  },
  {
    q: "Do you offer dairy-free and dietary options?",
    a: "Absolutely. We carry dairy-free milk alternatives for all beverages and can accommodate a range of dietary needs across our paninis and baked goods. Just note your requirements in the quote form.",
  },
  {
    q: "How far in advance should I book?",
    a: "We recommend booking 4–8 weeks ahead, especially for weddings and peak-season events. That said, reach out anytime — we'll do our best to accommodate last-minute requests.",
  },
  {
    q: "Can we customize the menu and cups?",
    a: "Yes! We love designing signature drinks for your event and can discuss custom or themed touches. Custom cakes for special occasions are also available by request.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-[#FAF7F2]">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <p className="uppercase tracking-[0.2em] text-xs font-semibold text-[#8B5E3C] mb-4">
            Good to Know
          </p>
          <h2 className="font-serif-display text-4xl md:text-5xl font-semibold text-[#2C2621] tracking-tight">
            Frequently asked questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-[#E5DFD3]"
            >
              <AccordionTrigger className="text-left font-serif-display text-xl md:text-2xl font-medium text-[#2C2621] hover:text-[#8B5E3C] hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#594D42] text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
